import React, { useContext, useEffect, useState } from 'react';
import { BaseURL } from '../../../../../Files/BaseURL';
import AlertContext from '../../../../../Context/Alert/AlertContext';
import PricingCard from '../../../../../components/pricingCards/pricingCards';
import { FaSpinner } from 'react-icons/fa'; // Spinner icon for loading
import { useLocation, useNavigate } from 'react-router-dom';

const ChoosePlan = () => {
    const [BusinessAccounts, setBusinessAccounts] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false); // To manage submission state
    const { showAlert } = useContext(AlertContext);

    const location = useLocation()
    const navigate = useNavigate()

    // Fetch Available Pricing Plans
    const fetchPricing = async () => {
        try {
            const response = await fetch(`${BaseURL}/api/portfolio/businessprice`);
            if (!response.ok) {
                showAlert('Failed to fetch pricing plans.','danger');   
            }
            const data = await response.json();
            setBusinessAccounts(data);
        } catch (error) {
            console.error('Error fetching pricing plans:', error);
            showAlert(error.message || 'Error fetching pricing plans.', 'danger');
        }
    };

    // Handle Subscription Submission
    const handleSubmit = async (businessId) => {
        // Prevent multiple submissions
        if (isSubmitting) return;

        // Validate businessId
        if (!businessId) {
            showAlert('Invalid plan selected.', 'danger');
            return;
        }

        setIsSubmitting(true);

        try {
            const authToken = localStorage.getItem('p@token');
            if (!authToken) {
                showAlert('Authentication token not found. Please log in.', 'danger');
                setIsSubmitting(false);
                return;
            }

            const response = await fetch(`${BaseURL}/api/business/freelancesetup/subScription/${businessId}`, {
                method: 'POST',
                headers: {
                    'auth-token': authToken,
                },
            });

            const result = await response.json();

            if (response.ok && result.success && result.approvalLink) {
                showAlert(result.message || 'Subscription created successfully!', 'success');
                // Redirect to PayPal approval link
                window.location.href = result.approvalLink.href; // Assuming approvalLink has href
            } else {
                // Handle specific error messages from backend
                showAlert(result.message || 'Failed to create subscription.', 'danger');
            }
        } catch (error) {
            console.error('Error during subscription:', error);
            showAlert('An unexpected error occurred. Please try again later.', 'danger');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSubscriptionUpdate = async (subscriptionID,businessType) => {
        try {
            const authToken = localStorage.getItem('p@token');
            const response = await fetch(`${BaseURL}/api/business/freelancesetup/addSubScription`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    "auth-token": authToken,
                },
                body: JSON.stringify({ SubScriptionID: subscriptionID,businessType:businessType })
            });

            const result = await response.json();
            if (response.ok) {
                showAlert('Subscription updated successfully!', 'success');
                // Navigate the user to another page or refresh the page
                navigate('/user-dashboard');
            } else {
                showAlert(result.message || 'Failed to update subscription.', 'danger');
            }
        } catch (error) {
            console.error('Error updating subscription:', error);
            showAlert('Internal Server Error', 'danger');
        }
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const subscriptionID = queryParams.get('subscription_id'); // Assuming the ID is in the param 'subscription_id'
        const businessType = queryParams.get('businessType'); // Assuming the ID is in the param 'subscription_id'

        if (subscriptionID) {
            // Call the API to update the subscription if the ID exists
            handleSubscriptionUpdate(subscriptionID,businessType);
        }else{
            fetchPricing();
        }
    }, [location]);

    

    return (
        <div className='flex flex-col gap-4 items-center pt-8'>
            <h2 className='font-pop text-xl font-semibold'>Choose Your Plan</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-center p-2 flex-wrap mt-10">
                {BusinessAccounts.length > 0 ? (
                    BusinessAccounts
                        .filter(item => item.For === "Seller")
                        .map((item) => (
                            <div key={item._id}>
                                <PricingCard
                                    buttontext={"Subscribe"}
                                    item={item}
                                    subfunction={true}
                                    submit={() => handleSubmit(item._id)}
                                    isSubmitting={isSubmitting}
                                />
                            </div>
                        ))
                ) : (
                    <p className="text-gray-500">No plans available at the moment.</p>
                )}
            </div>
        </div>
    );
};

export default ChoosePlan;
